import { Component, Input, OnInit } from '@angular/core';
import { ListService } from '../../../../shared/services/list.service';
import { UserService } from '../../../../services/user.service';
import { ListTableComponent } from '@ppl/ui';

@Component({
  selector: 'ppl-view-timesheets',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './view-timesheets.component.html',
  styleUrl: './view-timesheets.component.css',
})
export class ViewTimesheetsComponent implements OnInit {
  programName: any;
  @Input() claimDetailId: any;
  claimTimesheetData: any[] = [];
  cols = [
    {
      field: 'timesheetId',
      header: 'Timesheet ID',
      jsonpath: 'timesheetId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerName',
      header: 'Participant Name',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'participantPplId',
      header: 'Participant PPL ID',
      jsonpath: 'participantPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
      isClickable: true
    },
    {
      field: 'serviceDuration',
      header: 'Service Duration',
      jsonpath: 'serviceDuration',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'billedUnits',
      header: 'Billed Units',
      jsonpath: 'billedUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Paid Units',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'processingStatusDescription',
      header: 'Processing Status',
      jsonpath: 'processingStatusDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'businessStatusDescription',
      header: 'Business Status',
      jsonpath: 'businessStatusDescription',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  constructor(
    private listService: ListService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.searchClaimTimesheetData();
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    startingPageNumber = 1,
    recordsPerPage = 20
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: recordsPerPage,
      startingPageNumber: startingPageNumber,
      searchParam: [
        {
          jsonPath: 'batchClaimId',
          value: this.claimDetailId,
          operator: 'Equal',
        },
      ],
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ['desc'],
    };
    return payload;
  }

  searchClaimTimesheetData(startingPageNumber = 1, recordsPerPage = 20) {
    const processedPayload = this.buildRequestPayload(
      'billlingClmAdjTimesheets',
      'createdDate',
      startingPageNumber,
      recordsPerPage
    );

    this.listService
      .getListData(processedPayload, 'claimadj')
      .subscribe((data: any) => {
        const records = data.responsedata ?? [];
        // Accumulate pages so the grid can offer a probe page and detect the
        // end of this unknown-total list.
        this.claimTimesheetData = startingPageNumber > 1
          ? [...this.claimTimesheetData, ...records]
          : records;
      });
  }

  onPageLoad(event: any) {
    this.searchClaimTimesheetData(event.startingPageNumber ?? 1, event.rows ?? 20);
  }
}
